export enum ResponseCode {
  // SUCCESS = '00',
  SUCCESS_01 = '01',
  SUCCESS = 200
}
export enum checkData {
  DU_LIEU_MAC_DINH = 'Dữ liệu mặc định',
  DU_LIEU_DA_XOA = 'Dữ liệu đã xoá'
}
export enum CheckCreateOrUpDateOrCopy {
  CREATE = 'CREATE',
  COPY = 'COPY',
  UPDATE = 'UPDATE'
}
export enum StatusWorkEnum {
  LEAVE = '0',
  WORKING = '1',
  MATERNITY_LEAVE = '2',
  SUSPENSION = '3',
  WAITING_FOR_LEAVE = '4',
  DIEU_CHUYEN_CTY = '5'
}

export enum ObjectTypeEnum {
  SQ = 'SQ',
  QNCN = 'QNCN',
  CNVCQP = 'CNVCQP',
  HDLD = 'HDLD',
  HDTV = 'HDTV'
}

export enum CalculateTypeEnum {
  AVG_THREE_MONTHS = 'AVG_THREE_MONTHS',
  AVG_SIX_MONTHS = 'AVG_SIX_MONTHS',
  AVG_THREE_MONTHS_GROWTH = 'AVG_THREE_MONTHS_GROWTH',
  AVG_SIX_MONTHS_GROWTH = 'AVG_SIX_MONTHS_GROWTH',
  IMPACT_THREE_MONTHS_GROWTH = 'IMPACT_THREE_MONTHS_GROWTH',
  IMPACT_SIX_MONTHS_GROWTH = 'IMPACT_SIX_MONTHS_GROWTH'
}

export enum Cycle {
  MONTH = 'Tháng',
  QUARTER = 'Quý',
  YEAR = 'Năm'
}

export enum configCycle {
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  YEAR = 'YEAR'
}

export enum ConfigType {
  FEATURE = 'Nghiệp vụ',
  FUNCTION = 'Tính năng'
}

export enum WarningMethod {
  NOTIFY = 'Notify',
  EMAIL = 'Email',
}

export enum WarningMethodLabel {
  NOTIFY_LABEL = 'Thông báo',
  EMAIL_LABEL = 'Email',
}

export enum StatusAdjust {
  NEW = '1',
  CANCEL_REQUEST = '3',
  AWAITING_APPROVAL = '2',
  APPROVED = '4',
  REJECT = '5'
}

export enum StatusStep {
  WAIT = 'wait',
  PROCESS = 'process',
  FINISH = 'finish',
  ERROR = 'error'
}

export enum ReportType {
  KIT_REPORT = 'KIT_REPORT',
  CARD_REVENUE_REPORT = 'CARD_REVENUE_REPORT',
  SALE_CHANEL_REPORT = 'SALE_CHANEL_REPORT',
  D2D_SALE_KIT_CHANEL_REPORT = 'D2D_SALE_KIT_CHANEL_REPORT'
}

export enum KitReport {
  KIT_SALES_QUANTITY_AND_REVENUE_REPORT = 'KIT_SALES_QUANTITY_AND_REVENUE_REPORT',
  KIT_SALES_QUANTITY_REPORT = 'KIT_SALES_QUANTITY_REPORT',
  SUB_ACTIVIE_MONTH_N_1_HAVE_15C3D_IN_MONTH_N_REPORT = 'SUB_ACTIVIE_MONTH_N_1_HAVE_15C3D_IN_MONTH_N_REPORT',
  SUB_ACTIVIE_MONTH_N_1_HAVE_REFILL_IN_MONTH_N_REPORT = 'SUB_ACTIVIE_MONTH_N_1_HAVE_REFILL_IN_MONTH_N_REPORT',
  SUB_ACTIVIE_MONTH_N_1_HAVE_EXCHANGE_DATA_OSJA_IN_MONTH_N_REPORT = 'SUB_ACTIVIE_MONTH_N_1_HAVE_EXCHANGE_DATA_OSJA_IN_MONTH_N_REPORT'
}

export enum PARAMETER {
  TOURNAMENT_TYPE = 'TOURNAMENT_TYPE',
  AWARD_TYPE = 'AWARD_TYPE',
  LESSON_TYPE = 'LESSON_TYPE',
  CLASS = 'CLASS',
  ACADEMIC_TITLE = 'ACADEMIC_TITLE',
  ACADEMIC_EVALUATION = 'ACADEMIC_EVALUATION',
  ACADEMIC_COMMENT = 'ACADEMIC_COMMENT',
  GENDER = "GENDER",
  TEAM = "TEAM",
  TITLE = "TITLE", //Chuc danh
  COACH_CONTRACT = "COACH_CONTRACT", //Chuc danh
  LINEUP = "LINEUP", // đội hình
  MATCH_EVENT = "MATCH_EVENT", // Loại sự kiện
  DISCIPLINE_TYPE = "DISCIPLINE_TYPE", // Loại hình thức kỷ luật
  PROMOTION_FLAG = "PROMOTION_FLAG", // trạng thái lên lớp
  PLAYER_POSITION = "PLAYER_POSITION", // Vị trí cầu thủ
  HEALTH_ISSUE_TYPE = "HEALTH_ISSUE_TYPE", // Loại chấn thương
  TREATMENT_STATUS = "TREATMENT_STATUS", // Trạng thái điều trị chấn thương
}

export enum TOURNAMENT {
  CHINH_THUC = 'Chính thức',
  GIAO_HUU = 'Giao hữu'
}

export enum SCOREING_METHOD {
  GRADING_SCALE = 'GRADING_SCALE',
  COMMENT = 'COMMENT',
  EVALUATION = 'EVALUATION',
}

export enum COMMENT_TYPE {
  d = 'Đ', // Đạt
  kd = 'KĐ', // Không đạt
  g = 'G', // Giỏi
  k = 'K', // Khá
  tb = 'TB', // Trung bình
}

export enum EVALUATION_TYPE {
  d = 'Đ', // Đạt
  kd = 'KĐ', // Không đạt
}

export enum LESSON_TYPE {
  PROFESSIONAL = 'PROFESSIONAL', // Chuyên môn
  CULTURE = 'CULTURE', // Văn hóa
  OTHER = 'OTHER', // Khác
}

export enum LESSON_TYPE2 {
  PROFESSIONAL = 'Chuyên môn', // Chuyên môn
  CULTURE = 'Văn hóa', // Văn hóa
  OTHER = 'Khác', // Khác
}

export enum SEMESTER {
  SEMESTER1 = 'SEMESTER1',
  SEMESTER2 = 'SEMESTER2',
  FINAL = 'FINAL',
}

// dùng cho dropdown năm học
export enum ACADEMIC_YEAR_STATUS {
  UPCOMING = -1, // Sắp diễn ra
  ONGOING = 0, // Đang diễn ra
  COMPLETED = 1, // Hoàn thành
}

export enum USER_TYPE {
  NULL = 'NULL',
  PLAYER = 'PLAYER',
  COACH = 'COACH',
}

export enum ACADEMIC_TITLE {
  EXCELLENT = 'excellent', // Giỏi
  GOOD = 'good',           // Khá
}

// dùng cho cả trạng thái cầu thủ common
export enum PLAYER_ACQUISITION_STATUS {
  REGISTERED = 'REGISTERED', // TIẾP NHẬN
  IN_TRAINING = 'IN_TRAINING', // ĐAMG ĐÀO TẠO
  INJURED = 'INJURED', // CHẤN THƯƠNG
  ON_LOAN = 'ON_LOAN', // CHO MƯỢN
  RELEASED = 'RELEASED', // THANH LÝ
  TRANSFERRED = 'TRANSFERRED', // CHUYỂN NHƯỢNG
  CURRENTLY_PLAYING = 'CURRENTLY_PLAYING', // ĐANG THI ĐẤU
}

export enum PLAYER_ACTION_STATUS {
  INJURY  = 'INJURY', // CHẤN THƯƠNG
  ON_LOAN = 'ON_LOAN', // CHO MƯỢN
  RELEASE  = 'RELEASE', // THANH LÝ
  TRANSFER = 'TRANSFER', // CHUYỂN NHƯỢNG
  ACTIVE = 'ACTIVE', // KÍCH HOẠT
  ROTATE = 'ROTATE', // XOAY VÒNG
}

export enum COACH_STATUS {
  ACTIVE_COACH = 'ACTIVE_COACH', // Đang làm việc
  INACTIVE_COACH = 'INACTIVE_COACH', // Nghỉ việc
}

export enum UNIT {
  CHAM = 'CHAM',
  CM = 'CM',
  MET = 'MET',
  QUA = 'QUA',
  NHIP_P = 'NHIP_P',
  GIAY = 'GIAY'
}

export enum TYPE_SCORE {
  TU_DONG_QUY_DOI_DIEM = 'AUTO_CONVERT_SCORE',
  KHONG_TINH_DIEM = 'NO_SCORE_CALCULATION',
  NHAP_CONG_THUC = 'USE_CUSTOM_FORMULA',
}

export enum ROUTINE_MEDICAL_CHECKUP_STATUS {
  NOT_YET_STARTED = 'NOT_YET_STARTED', // Chưa bắt đầu
  IN_PROGRESS = 'IN_PROGRESS',     // Đang diễn ra
  FINISHED = 'FINISHED'    // Kết thúc
}

// LOẠI KHÁM
export enum EXAMINATION_TYPE {
  KHAM_SUC_KHOE_DINH_KY = 'DINH_KY',
  KHAM_SUC_KHOE_TRUOC_THI_DAU = 'TRUOC_THI_DAU',
  KHAM_Y_HOC_TDTT_DAU_VAO = 'Y_HOC_TDTT_DAU_VAO',
  KHAM_Y_TE_TUYEN_DAU_VAO = 'Y_TE_TUYEN_DAU_VAO',
  KHAM_SUC_KHOE_TRUOC_NGHI_HE = 'SUC_KHOE_TRUOC_NGHI_HE',
  KHAM_SUC_KHOE_SAU_NGHI_HE = 'SUC_KHOE_SAU_NGHI_HE',
  KHAM_SUC_KHOE_TRUOC_NGHI_TET = 'SUC_KHOE_TRUOC_NGHI_TET',
  KHAM_SUC_KHOE_SAU_NGHI_TET = 'SUC_KHOE_SAU_NGHI_TET'
}

export enum EXAMINATION_STATUS {
  CHUA_CO_KET_QUA = 1,   // Chưa có kết quả
  DA_CO_KET_QUA = 2      // Đã có kết quả
}

// KỲ SÁT HẠCH
export enum QUATIFICATION_TEST {
  NOT_STARTED = 'NOT_STARTED',   //chưa bắt đầu
  IN_PROGRESS = 'IN_PROGRESS', //Trong tiến trình
  RESULT_AVAILABLE = 'RESULT_AVAILABLE', //Đã có kết quả
  COMPLETED = 'COMPLETED', //Hoàn thành
  NOT_FORWARDED_TO_TECHNICAL_REVIEW = 'NOT_FORWARDED_TO_TECHNICAL_REVIEW', //Chưa đánh giá năng khiếu
  FORWARDED_TO_TECHNICAL_REVIEW = 'FORWARDED_TO_TECHNICAL_REVIEW', //Đã đánh giá năng khiếu
}

export enum QUATIFICATION_TEST_NUMBER {
  NOT_STARTED = 0,   //chưa bắt đầu
  IN_PROGRESS = 1, //Trong tiến trình
  RESULT_AVAILABLE = 2, //Đã có kết quả
  COMPLETED = 3, //Hoàn thành
  NOT_FORWARDED_TO_TECHNICAL_REVIEW = 4, //Chưa đánh giá năng khiếu
  FORWARDED_TO_TECHNICAL_REVIEW = 5, //Đã đánh giá năng khiếu
}

export enum INJURY_STATUS {
  DA_KHOI = 'RECOVERED', // Đã khỏi
  CHAN_THUONG = 'INJURED', // Chấn thương
}

export enum TYPE_ADJUST_PLAYER {
  LIQUIDATION = 'LIQUIDATION',
  LEND = 'LEND',
  ROTATION = 'ROTATION',
  TRANSFER = 'TRANSFER',
}

export enum LOAI_CHI_SO {
  COUNT = 'COUNT',
  DIRECTIONAL = 'DIRECTIONAL',
  TARGET_TIME = 'TARGET_TIME',
}

export enum CACH_TINH {
  INPUT_RESULT = 'INPUT_RESULT',
  FORMULA = 'FORMULA',
}

// loại sát hạch
export enum QUATIFICATION_TEST_TYPE {
  DINH_KY = 'PERIODIC', // Định kỳ
  THI_TUYEN_DAU_VAO = 'ENTRY', // Thi tuyển đầu vào
}

// ĐIỂM DANH VĂN HÓA
export enum CULTURAL_ROLL_CALL {
  PRESENT = 'PRESENT', // Có mặt
  ABSENT_UNEXECUSED = 'ABSENT_UNEXCUSED', // Vắng mặt không phép
  ABSENT_EXCUSED = 'ABSENT_EXCUSED' // Vắng mặt có phép
}
export enum LOAI_TIEU_CHI {
  TIEU_CHI_THE_LUC = 'PHYSICAL',
  TIEU_CHI_KY_NANG = 'SKILL',
  TIEU_CHI_KY_THUAT = 'TECHNIQUEFIELDPLAYER',
  TIEU_CHI_KY_THUAT_THU_MON = 'TECHNIQUEGOALKEEPER',
  BA_TEST = 'THREETESTGOALKEEPER',
  DANH_GIA_Y_TE = 'HEALTHASSESSMENT',
  DANH_GIA_NANG_KHIEU = 'ENTRYTALENT'
}

export enum TAB_QUAN_LY_KY_SAT_HACH {
  TONG_HOP = 'SUMMARY',
  TIEU_CHI_THE_LUC = 'PHYSICAL',
  TIEU_CHI_KY_THUAT = 'TECHNIQUEFIELDPLAYER',
  TIEU_CHI_KY_NANG = 'SKILL',
  TIEU_CHI_KY_THUAT_THU_MON = 'TECHNIQUEGOALKEEPER',
  BA_TEST = 'THREETESTGOALKEEPER',
  // TONG_HOP_THU_MON_SAT_HACH_DINH_KY = 'TONG_HOP_THU_MON_SAT_HACH_DINH_KY',
  // TONG_HOP_THI_TUYEN_DAU_VAO = 'SUMMARY',
  // TIEU_CHI_THE_LUC_THI_TUYEN_DAU_VAO = 'PHYSICAL',
  // TIEU_CHI_KY_THUAT_THI_TUYEN_DAU_VAO = 'TECHNIQUE_FIELD_PLAYER',
  // TIEU_CHI_KY_NANG_THI_TUYEN_DAU_VAO = 'SKILL',
  DANH_GIA_Y_TE = 'HEALTHASSESSMENT',
  DANH_GIA_NANG_KHIEU = 'ENTRYTALENT'
}


export enum STATUS_MAIN {
  ACTIVE = 1, // Đang hoạt động
  INACTIVE = 0 // Vô hiệu hóa
}

export enum TEAM {
  // U11 = 'U11',
  U13 = 'U13',
  U14 = 'U14',
  U15 = 'U15',
  U17 = 'U17',
  U19 = 'U19',
  U21 = 'U21',
  TEAM1 = 'Đội 1',
  U21Plus = 'U21Plus'
}

export enum COT_CAN_THIET_LAP_CONG_THUC {
  TOTAL_SCORE = 'TOTAL_SCORE',
  CONVERTED_SCORE = 'CONVERTED_SCORE',
  PHYSICAL = 'PHYSICAL',
  TECHNICAL = 'TECHNICAL',
  THINKING = 'THINKING',
}

export enum TEN_LOAI_TIEU_CHI {
  TIEU_CHI_THE_LUC = 'Tiêu chí thể lực',
  TIEU_CHI_KY_NANG = 'Tiêu chí kỹ năng',
  TIEU_CHI_KY_THUAT = 'Tiêu chí kỹ thuật',
  TIEU_CHI_KY_THUAT_THU_MON = 'Tiêu chí kỹ thuật thủ môn',
  BA_TEST = '3 Test',
  TONG_HOP = 'Tổng hợp',
  // TIEU_CHI_THE_LUC_THI_TUYEN_DAU_VAO = 'Tiêu chí thể lực',
  // TIEU_CHI_KY_THUAT_THI_TUYEN_DAU_VAO = 'Tiêu chí kỹ thuật',
  // TIEU_CHI_KY_NANG_THI_TUYEN_DAU_VAO = 'Tiêu chí kỹ năng',
  DANH_GIA_Y_TE = 'Đánh giá y tế',
  DANH_GIA_NANG_KHIEU = 'Đánh giá năng khiếu',

}

export enum PROFESSIONAL_CLASS_STATUS {
  NOT_STARTED = 'NOT_STARTED', // Chưa bắt đầu
  IN_PROGRESS = 'IN_PROGRESS', // Đang diễn ra
  COMPLETED = 'COMPLETED', // Kết thúc
}

export enum CATEGORY_WEEKLY_PLAN {
  WARM_UP = 'WARM_UP', // Khởi động
  MAIN = 'MAIN', // Trọng động
  COOL_DOWN = 'COOL_DOWN', // Kết thúc
}

export enum FOOTBALL_MATCH_STATUS {
  PENDING = 'PENDING',         // Đang chờ
  IN_PROGRESS = 'IN_PROGRESS',         // Đang thi đấu
  COMPLETED = 'COMPLETED',       // Kết thúc
  POSTPONED = 'POSTPONED',     // Tạm hoãn
}

export enum AWARD_MIX_TYPE {
  AWARD = 'AWARD',
  DISCIPLINE = 'DISCIPLINE'
}

export enum NOIDUNG_MUCTIEU {
  TONGTHOIGIAN = 1,
  DIEM = 2,
  TONGDIEM = 3,
  DIEMQUYDOI = 4
}
